import { UserProfileModel } from 'src/app/auth/models/user-profile.model';
import { ExternalProviderEnum } from 'src/app/organizations/models/external-account.model';
import { EnumDictionary } from 'src/app/shared/list-utils';

// default support site
export const defaultHelpCenterUrl = 'https://support.biodigital.com/hc/en-us';

// mapping of external provider to support url
export const externalSupportUrls: EnumDictionary<ExternalProviderEnum, string> = {
  [ExternalProviderEnum.WoltersKluwer]: 'https://tools.ovid.com/support/index_inner.html',
};

/**
 * Gets the help center URL.
 * @param profile The user's profile.
 * @returns The help center URL.
 */
export function getHelpCenterUrl(profile: UserProfileModel): string {
  return defaultHelpCenterUrl;
}

/**
 * Gets if support enabled for the user.
 * Valid premium account or team (valid or expired) users not managed externally.
 * @param profile The user's profile.
 * @returns If customer support is enabled.
 */
export function getSupportEnabled(profile: UserProfileModel): boolean {
  const isValidPremium = profile?.premium_account_valid === true;
  const isTeamAccount = profile?.premium_account_type === 'group';

  return isValidPremium || isTeamAccount;
}

/**
 * Gets if contact enabled for the user.
 * Valid for supported accounts not managed externally.
 * @param profile The user's profile.
 * @returns If contacting support enabled.
 */
export function getContactEnabled(profile: UserProfileModel): boolean {
  const isExternalAccount = profile?.organizations[0]?.external_account?.is_external_account;
  return !isExternalAccount && getSupportEnabled(profile);
}

/**
 * Gets the contact support url for the user.
 * @param profile The user's profile.
 * @returns
 */
export function getSupportUrl(profile: UserProfileModel): string {
  const externalAccountProvider =
    profile?.organizations[0]?.external_account?.external_account_provider;
  const supportUrl = externalSupportUrls[externalAccountProvider];
  return supportUrl;
}
